import styled, { css } from 'styled-components';
import {
  fillFlatNewIconWithColor,
  fillVillaIconWithColor,
  FlexCenteredColumn,
  transitionStyles
} from '../../styled/common';
import { Typography } from '../ui/Typography';

const containerStateStyles = (color: string) => css`
  border-color: ${({ theme }) => theme.colors.systemColors.blue};
  ${transitionStyles('border-color')}

  span {
    ${transitionStyles('color')}
    color: ${color};
  }

  &:nth-of-type(1),
  &:nth-of-type(4),
  &:nth-of-type(6),
  &:nth-of-type(7) {
    svg path,
    svg rect {
      ${transitionStyles('stroke')}
      stroke: ${color};
    }
  }

  &:nth-of-type(2) {
    ${fillFlatNewIconWithColor(color)};
  }

  &:nth-of-type(3) {
    ${fillVillaIconWithColor(color)};
  }

  &:nth-of-type(5) {
    svg path {
      fill: ${color};
      ${transitionStyles('fill')}
    }
  }
`;

const defaultBaseSvgStyles = css`
  svg {
    fill: ${({ theme }) => theme.colors.text.primary};
    transition: fill 0.3s;
  }
`;

const defaultHoverStyles = css`
  border-color: ${({ theme }) => theme.colors.systemColors.blue};

  svg {
    fill: ${({ theme }) => theme.colors.systemColors.blue};
  }

  span {
    color: ${({ theme }) => theme.colors.systemColors.blue};
  }
`;

export const StepModalOption = styled(FlexCenteredColumn)<{
  $isDefaultStyles?: boolean;
}>`
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 14px;
  border: 1px solid ${({ theme }) => theme.colors.border.secondary};
  padding: 30px 15px;
  gap: 15px;
  cursor: pointer;

  ${({ $isDefaultStyles }) => $isDefaultStyles && defaultBaseSvgStyles};

  @media (hover: hover) {
    &:hover {
      ${({ theme, $isDefaultStyles }) => {
        if ($isDefaultStyles) return defaultHoverStyles;
        return containerStateStyles(theme.colors.systemColors.blue);
      }}
    }
  }
`;

export const StepModalOptionText = styled(Typography)``;
